import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

// index.html ships the TeamCare favicon and title; capture them once so they stay the single source of truth.
const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
const DEFAULT_FAVICON = favicon?.href ?? '';
const DEFAULT_TITLE = document.title;

// Brands the browser tab with the current practice's logo and name, falling back to TeamCare.
export const usePracticeBranding = () => {
  const practice = useSelector((s: RootState) => s.auth.practice);

  useEffect(() => {
    if (favicon) favicon.href = practice?.logo || DEFAULT_FAVICON;
    document.title = practice?.title || DEFAULT_TITLE;
  }, [practice]);
};
